<div class="pdf-container">
  <iframe [src]="pdfUrl" class="pdf-viewer" type="application/pdf"></iframe>
</div>
